import ActionController from './action-controller';
import PublicPagesApi from 'mewe/api/public-pages-api-unauth';
import GroupPublicStore from 'mewe/stores/group-public-store';
import GroupStore from 'mewe/stores/group-store';
import EnvironmentUtils from 'mewe/utils/environment-utils';
import { ds } from 'mewe/stores/ds';
import { inject as service } from '@ember/service';

export default ActionController.extend({
  router: service('router'),

  actions: {
    fetchPublicGroupByPublicId(groupPublicId) {
      if (!groupPublicId) {
        return;
      }

      // it's important for public pages to be notified about refetching group data, e.g after login
      GroupPublicStore.send('update', { isFetching: true }, groupPublicId);

      PublicPagesApi.group(groupPublicId)
        .then((data) => {
          GroupPublicStore.send('handle', data, groupPublicId);
        })
        .catch((resp) => {
          if (resp && resp.status === 404) {
            location.href = '/404';
          } else if (resp && resp.status === 401) {
            // go to group page (not public 'join/groupid' because it can be private group like in SG-14124)
            window.location = '/login?next=/group/' + groupPublicId.replace('id=', '');
          }
        });
    },

    fetchPublicGroupById(groupId, postId) {
      if (!groupId) {
        return;
      }

      let group = GroupStore.getState({ id: groupId });

      if (group && !group.isFetching && group.isPublic === false) {
        return false;
      }
      const isPostForDialog = postId !== undefined;
      PublicPagesApi.groupById(groupId)
        .then((groupData) => {
          if (groupData) {
            if (groupData.loggedIn) {
              if (isPostForDialog && !groupData.isMember) {
                this.router.transitionTo('app.myworld.single-post', postId, {
                  queryParams: { groupId: groupId },
                });
              }
              if (
                !isPostForDialog &&
                !groupData.isInvited &&
                !groupData.isMember &&
                groupData._links &&
                groupData._links.publicUrl
              ) {
                location.href = EnvironmentUtils.correctHostnameAndPort(groupData._links.publicUrl.href);
              }
            } else if (groupData._links && groupData._links.publicUrl) {
              location.href = EnvironmentUtils.correctHostnameAndPort(groupData._links.publicUrl.href);
            }
          }
        })
        .catch((resp) => {
          if ((resp && resp.status === 404) || !group.isPublic) {
            location.href = '/404';
          } else if (resp && resp.status === 401) {
            window.location = '/login?next=/group/' + groupId + location.hash;
          }
        });
    },

    fetchPublicEvent(publicId) {
      if (!publicId) {
        return;
      }

      PublicPagesApi.getEvent(publicId)
        .then((data) => {
          ds.eventPublic.setProperties({
            eventData: data.event,
            participation: data.participation,
            isLoggedIn: data.isUserLoggedIn,
            eventPublicId: publicId,
            isFetching: false,
          });
        })
        .catch((resp) => {
          if (resp && resp.status === 404) {
            location.href = '/404';
          }
        });
    },

    fetchPublicEventById(eventId) {
      if (!eventId) {
        return;
      }

      PublicPagesApi.getEventById(eventId)
        .then((eventData) => {
          if (eventData && eventData.event && eventData.event._links && eventData.event._links.publicUrl) {
            location.href = eventData.event._links.publicUrl.href;
          }
        })
        .catch((resp) => {
          if (resp && resp.status === 404) {
            location.href = '/404';
          } else if (resp && resp.status === 401) {
            window.location = '/login?next=/event/' + eventId + location.hash;
          }
        });
    },
  },
});
